import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

/**
 * Enterprise RBAC gate. Legacy `admin` role and enterprise `super_admin`
 * are treated as equivalent — any route protected with roles=["admin"]
 * automatically admits super_admin, and vice versa.
 */
const SUPER_ADMIN = new Set(["admin", "super_admin"]);

export const ProtectedRoute = ({ children, roles }) => {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <div className="p-10 text-sm text-muted-foreground">Loading…</div>;
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  if (roles && !roles.includes(user.role)) {
    // Super-admin bypass: if the route asks for admin (or vice versa), let super_admin/admin through.
    const asksAdmin = roles.some(r => SUPER_ADMIN.has(r));
    if (asksAdmin && SUPER_ADMIN.has(user.role)) return children;
    return <Navigate to="/" replace />;
  }
  return children;
};

export default ProtectedRoute;
